// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const ChevronLeftIcon = props => <Icon {...props} dangerouslySetIcon={'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M14 17a1 1 0 01-.71-.29l-4-4a1 1 0 010-1.42l4-4a1 1 0 111.42 1.42L11.41 12l3.3 3.29a1 1 0 010 1.42A1 1 0 0114 17z" fill="currentColor"/></svg>'} />;

ChevronLeftIcon.displayName = 'ChevronLeftIcon';

export default ChevronLeftIcon;
